import {
  AppRolesApi,
  AppRolesGetActiveRoleAssignmentsRequest,
  AppRolesGetAvailableRolesRequest,
  AppRolesGetAvailableSecurityGroupsRequest,
  AppRolesUpdateRoleAssignmentsPostRequest,
  GuidReferenceReadModelPagedList,
  InitOverrideFunction,
  RolesAndAssignmentsReadModel,
  StringReferenceReadModelPagedList,
  UpdateRoleAssignmentsResponse,
} from "../../../@api";

export class AppRolesApiService
  implements Omit<AppRolesApi, `${string}Raw` | "withMiddleware" | "withPreMiddleware" | "withPostMiddleware">
{
  constructor(private readonly api: AppRolesApi) {}

  public appRolesGetActiveRoleAssignments(
    requestParameters?: AppRolesGetActiveRoleAssignmentsRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<RolesAndAssignmentsReadModel> {
    return this.api.appRolesGetActiveRoleAssignments(requestParameters, initOverrides);
  }

  public appRolesGetAvailableRoles(
    requestParameters?: AppRolesGetAvailableRolesRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<GuidReferenceReadModelPagedList> {
    return this.api.appRolesGetAvailableRoles(requestParameters, initOverrides);
  }

  public appRolesGetAvailableSecurityGroups(
    requestParameters?: AppRolesGetAvailableSecurityGroupsRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<StringReferenceReadModelPagedList> {
    return this.api.appRolesGetAvailableSecurityGroups(requestParameters, initOverrides);
  }

  public appRolesUpdateRoleAssignmentsPost(
    requestParameters?: AppRolesUpdateRoleAssignmentsPostRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<UpdateRoleAssignmentsResponse> {
    return this.api.appRolesUpdateRoleAssignmentsPost(requestParameters, initOverrides);
  }
}
